<template>
  <div class="flex justify-center items-end gap-2">
    <div class="flex flex-col">
      <v-autocomplete
        v-model="callingNumberSelect"
        loading="true"
        color="secondary"
        background-color="white"
        dense
        outlined
        clearable
        item-text="country_name"
        item-value="value"
        item-color="secondary"
        aria-label=""
        :items="getAvailableCallingNumbers"
        :placeholder="$t('auto_dialer.choose_number')"
      >
        <template
          slot="selection"
          slot-scope="data"
        >
          {{ data.item.value }} {{ data.item.country_name ? `(${data.item.country_name})` : '' }}
        </template>
        <template
          slot="item"
          slot-scope="data"
        >
          {{ data.item.value }} {{ data.item.country_name ? `(${data.item.country_name})` : '' }}
        </template>
      </v-autocomplete>
      <v-text-field
        v-model="numberToCall"
        color="secondary"
        background-color="white"
        outlined
        dense
        clearable
        flat
        hide-details
        :placeholder="$t('auto_dialer.type_a_number')"
        @keyup.enter="callContact()"
      />
    </div>
    <v-btn
      class="elevation-0"
      :disabled="!isRegistered"
      fab
      dark
      width="46"
      height="46"
      color="accent"
      @click="callContact()"
    >
      <v-icon dark>
        $contacts-call-audio
      </v-icon>
    </v-btn>
    <v-btn
      class="elevation-0"
      :class="[$_breakpoints_mobile?
        'contacts__keypad--mobile': 'contacts__keypad']"
      :disabled="!isRegistered"
      fab
      dark
      width="46"
      height="46"
      color="accent"
      @click="openKeypad()"
    >
      <v-icon dark>
        $call-keypad
      </v-icon>
    </v-btn>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { breakpoints } from '@/mixins'

export default {
  data: () => ({
    numberToCall: '',
    callingNumberSelect: null,
  }),
  mixins: [breakpoints],
  computed: {
    ...mapGetters('webrtc', ['isRegistered']),
    ...mapGetters('callingNumbers', ['getSelectedCallingNumber', 'getAvailableCallingNumbers']),
  },
  watch: {
    callingNumberSelect(value) {
      if (value !== this.getSelectedCallingNumber) {
        this.$nextTick(() => { this.callingNumberSelect = this.getSelectedCallingNumber })
        this.changeCallingNumber(value)
      }
    },
    getSelectedCallingNumber: {
      handler(value) {
        this.callingNumberSelect = value
      },
      immediate: true,
    },
    isRegistered: {
      handler(value) {
        try {
          if (value && this.$route.query.supervision) {
            this.numberToCall = this.$route.query.supervision
            this.call({
              number: this.numberToCall,
              video: false,
            })
              .catch((e) => {
                const error = this.$t(`errors["${e.code}"]`)
                this.$emit('phone-error', error)
              })
          }
        } catch (error) {
          console.log(error)
        }
      },
    },
    numberToCall: {
      handler(value) {
        this.$nextTick(() => { this.numberToCall = value.replace(/[^\d#*]/, '') })
      },
    },
  },
  methods: {
    ...mapActions('webrtc', ['call']),
    ...mapActions('callingNumbers', ['changeCallingNumber']),
    callContact() {
      try {
        if (this.numberToCall.length === 0) {
          return
        }
        this.call({
          number: this.numberToCall,
          video: false,
        })
          .catch((e) => {
            const error = this.$t(`errors["${e.code}"]`)
            this.$emit('phone-error', error)
          })
      } catch (error) {
        console.log(error)
      }
    },
    openKeypad() {
      this.$store.commit('toggleDialogNumberVisibility', true)
    },
  },
  async mounted() {
    try {
      if (this.$route.query.supervision) {
        await this.$store.dispatch('settings/setRegisterEnabled', true)
      }
    } catch (error) {
      console.log(error)
    }
  },
}
</script>
